import { useQuery } from '@tanstack/react-query'
import { IUser, IUseUser } from 'api/types/user'
import { QUERY_KEY } from 'app/constants'
import { useLocalStorage } from 'lib/hooks/use-local-storage'
import { useEffect, useMemo } from 'react'

export const useUser = (): IUseUser => {
  const [userLocalStorage, setUserLocalStorage] = useLocalStorage<IUser | null>(
    'user',
    null,
  )

  const { data: user, isError } = useQuery<{ data: IUser }>({
    queryKey: [QUERY_KEY.user],
    enabled: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialData: userLocalStorage ? { data: userLocalStorage } : undefined,
  })

  useEffect(() => {
    if (!user || isError) setUserLocalStorage(null)
    else setUserLocalStorage(user.data)
  }, [isError, setUserLocalStorage, user])

  return useMemo(() => {
    return {
      user: user?.data ?? null,
      isError,
    }
  }, [isError, user?.data])
}
